import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag"
import store from './store'
import router from './router'
import { _isMobile, _isApp } from '@/utils'
import VueFilters from './libs/filters'
import VueImageComponent from './libs/image'
import 'vant/lib/index.css'
import 'vant/es/toast/style'
import {
  Button,
  NavBar,
  Dialog,
  Toast,
  Loading,
  Lazyload,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  ImagePreview,
  Badge,
  Picker,
  Divider,
  Popover,
  Popup,
  Empty,
  List,
  Cell,
  ActionSheet,
  Field,
  Skeleton,
  Uploader
} from 'vant'
import '@/assets/scss/app.scss';

console.log('***', location.href)

const htmlClass = []
const isH5View = !!_isMobile() || !!_isApp()
const isInIframe = window.frameElement
if (isInIframe) htmlClass.push('is-iframe')
if (isH5View) htmlClass.push('is-h5')
else htmlClass.push('is-pc')
const htmlElmt = document.documentElement || document.getElementsByTagName("html")[0] || document.querySelector("html")
htmlElmt.className += htmlClass.join(' ')
if (isH5View) {
  const initView = () => {
    // 定义全局 rem 基础值
    htmlElmt.style.fontSize = `${window.screen.width / 375 * 100}px`;
    // 在 webclip 的浏览器内会发生外层也出现卷轴, <html> 高度应该与 window.innerHeight 一致
    if (htmlElmt.getBoundingClientRect().height > window.innerHeight) {
      console.log('check height', htmlElmt.getBoundingClientRect().height, window.innerHeight)
      htmlElmt.style.height = window.innerHeight + 'px'
    }
  }
  initView()
  window.onresize = () => {
    initView()
  }
}
// CDN選址
cdnPing(() => {
  let app = createApp(App)
  // Gtag
  app.use(VueGtag, {
    config: { id: "G-9FR3N3ZM6T" }
  })

  app.use(router).use(router).use(store).mount('#app')
  app.use(VueFilters).use(VueImageComponent)
  app
    .use(Button)
    .use(Dialog)
    .use(Toast)
    .use(Loading)
    .use(Lazyload, {
      lazyComponent: true,
    })
    .use(Swipe)
    .use(SwipeItem)
    .use(Tab)
    .use(Tabs)
    .use(ImagePreview)
    .use(Badge)
    .use(Picker)
    .use(Divider)
    .use(Popover)
    .use(Popup)
    .use(Empty)
    .use(List)
    .use(Cell)
    .use(ActionSheet)
    .use(Field)
    .use(Skeleton)
    .use(Uploader)
})